export default __webpack_public_path__ + "fonts/Aller_It.ttf";